import {getTodoCollectionPath, type TodoDb} from '@cp/model';
import {collection, CollectionReference} from 'firebase/firestore';
import {firebaseFirestore} from '../../config/firebase';

export function getTodoCollection(uid: string): CollectionReference<TodoDb> {
  return collection(firebaseFirestore, getTodoCollectionPath(uid)) as CollectionReference<TodoDb>;
}
